module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('ul', [_c('li', [_c('h3', [_c('img', {
    staticClass: "fl mr10",
    attrs: {
      "src": "http://www.evhui.com/wp-content/themes/evhui3.0/public/images/footer_logo_icon.png",
      "width": "30",
      "height": "30",
      "alt": ""
    }
  }), _vm._v("关于电车汇")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "home",
    attrs: {
      "href": ""
    }
  }, [_vm._v("电车汇（evhui.com）")]), _vm._v("是一个专注于新能源电动汽车的资讯博客。"), _c('br'), _vm._v("通过微信、微博、手机端web向您推送第一手行业信息。"), _c('br'), _vm._v("我们立志于成为新能源汽车领域首屈一指的互联网科技公司。")])]), _vm._v(" "), _c('li', [_c('h3', [_c('img', {
    staticClass: "fl mr10",
    attrs: {
      "src": "http://www.evhui.com/wp-content/themes/evhui3.0/public/images/footer_contact_icon.png",
      "width": "30",
      "height": "30",
      "alt": ""
    }
  }), _vm._v("联系我们")]), _vm._v(" "), _c('p', [_vm._v("寻找融资、投稿、广告合作等事宜，"), _c('br'), _vm._v("可发送邮件至："), _c('a', {
    staticClass: "mail",
    attrs: {
      "href": "mailto:contact@evhui.com"
    }
  }, [_vm._v("contact@evhui.com")]), _c('br'), _vm._v("或致电：010-84084973")])]), _vm._v(" "), _c('li', [_c('h3'), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "mail",
    attrs: {
      "href": ""
    }
  }, [_vm._v("京ICP备12051403号-1")])]), _vm._v(" "), _c('p', [_vm._v("服务器由"), _c('a', {
    staticClass: "mail",
    attrs: {
      "href": ""
    }
  }, [_vm._v(" 互联港湾")]), _vm._v(" 友情赞助")]), _vm._v(" "), _c('p', [_vm._v("©2014 电车汇 |"), _c('a', {
    staticClass: "mail",
    attrs: {
      "href": ""
    }
  }, [_vm._v(" 站长统计")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-306f0d80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 567
// module chunks = 1